// What each built-in stage does today. These rules live in the API and webhook code, so the
// Service journey screen shows them read-only. Replies are [button, status, reply message, next].

const DECISION_REPLIES = [
  ["Approve", "Approve", "Approve reply", "Stay"],
  ["Reject", "Reject", "Reject reply", "Stay"],
  ["Callback", "Callback", "Callback reply", "Stay"],
  ["Clarify", "Ask to clarify", "Clarify reply", "Stay"],
];

export const BUILT_IN_RULES = {
  created: { trigger: "Booking saved", completion: "On group created", recipient: "None" },
  welcome: { trigger: "Customer joined", completion: "On send" },
  invites: { trigger: "Group created", completion: "On send", recipient: "Each member" },
  initial: {
    trigger: "Customer joined",
    completion: "On send",
    replies: [["Let's get started", "—", "None", "Inventory, then Estimate"]],
  },
  media: { trigger: "Manual · Let's get started", completion: "On send", attachment: "Photos and videos" },
  estimate: {
    trigger: "Manual · Let's get started",
    completion: "On send",
    attachment: "Document",
    replies: [["Approve", "Approve", "Approve reply", "Job Card"], ...DECISION_REPLIES.slice(1)],
  },
  jobcard: { trigger: "Manual · Approve on Estimate", completion: "On send", attachment: "Document" },
  progress: { trigger: "Manual", completion: "On send · On keyword", attachment: "Photos and videos" },
  parts_approval: { trigger: "Manual", completion: "On send", attachment: "Files" },
  parts: { trigger: "Manual", completion: "On send", replies: DECISION_REPLIES },
  pre_invoice: { trigger: "Manual", completion: "On send", attachment: "Document", replies: DECISION_REPLIES },
  invoice: { trigger: "Manual", completion: "On send", attachment: "Document", replies: DECISION_REPLIES },
  pre_delivery_feedback: {
    trigger: "After Escalation Metrics is sent",
    delay: "Set below",
    completion: "On reply",
    replies: [
      ["Approve", "Gatepass created", "None", "Next Service Due"],
      ["Excellent, Very Good, Good", "Gatepass created", "None", "Next Service Due"],
      ["Reject, Needs Improvement", "Reject", "None", "Stay"],
    ],
  },
  vehicle_delivered: {
    trigger: "Manual · WhatsApp keyword",
    completion: "On send",
    attachment: "Photos and videos",
    replies: [
      ["Vehicle Received", "Vehicle received", "None", "Feedback"],
      ["Report an Issue", "Reported an issue", "None", "Stay"],
    ],
  },
  next_service_due: { trigger: "Approve on Pre Delivery Feedback", delay: "Set below", completion: "On send", recipient: "Customer" },
  post_delivery_feedback: { trigger: "After Next Service Due is sent", delay: "Set below", completion: "On send", recipient: "Set below" },
};

// Where each built-in stage sits in a service visit. A stage the brand added takes the phase of
// the stage above it, so the list stays grouped whatever the order.
const PHASE_OF = {
  created: "Setup", invites: "Setup", welcome: "Setup", initial: "Setup",
  media: "Service", estimate: "Service", jobcard: "Service", progress: "Service", parts_approval: "Service", parts: "Service",
  pre_invoice: "Billing", invoice: "Billing",
  pre_delivery_feedback: "Delivery", vehicle_delivered: "Delivery",
  next_service_due: "Follow-up", post_delivery_feedback: "Follow-up",
};

// The phase heading each row sits under in the list: a phase heads the list once, where its first
// stage is, and a stage moved out of its phase stays under the heading above it.
export function rowPhases(rows) {
  let phase = "";
  const seen = new Set();
  return rows.map((r) => {
    const own = PHASE_OF[r.stage_key] || phase || "Setup";
    if (!seen.has(own)) {
      seen.add(own);
      phase = own;
    }
    return phase;
  });
}
